export const GIT_COMMIT = '946548122146823e85bf98cdf38a77ff48b88a3e';
